import { Component } from '@angular/core';

@Component({
    selector: 'gl-validation-history-page',
    templateUrl: './validation-history-page.component.html',
    styleUrls: ['./validation-history-page.component.scss']
})
export class ValidationHistoryPageComponent {}
